import { render } from "./DashboardButton.vue?vue&type=template&id=d74a9d6a"
const script = {}

import "./DashboardButton.vue?vue&type=style&index=0&id=d74a9d6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__